import { render } from "./UserSurvey.vue?vue&type=template&id=d1cd3990&scoped=true"
import script from "./UserSurvey.vue?vue&type=script&lang=js"
export * from "./UserSurvey.vue?vue&type=script&lang=js"

import "./UserSurvey.vue?vue&type=style&index=0&id=d1cd3990&scoped=true&lang=css"

import exportComponent from "../../../../../../vue-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1cd3990"]])

export default __exports__